import {
  Stack,
  TableCell,
  styled,
  tableCellClasses,
  Typography,
  Divider,
  Box,
} from '@mui/material'
import { useFieldArray, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useSubmissionsOverviewQuery } from 'services/submissions'
import { DocumentSubmissionRequirement } from './lots/map-to-form-values'
import { ITender } from 'types/tender'
import { Loading } from 'components/Loading'
import { useLotQuery } from 'services/lots'
import { LotInformation } from './lots/lot-infromation'
import { TablePagination } from 'components/TablePagination'
import { useQueryState } from 'react-router-use-location-state'
import { RequiredDocsSubmissionItem } from './required-docs-submission-item'

type Props = {
  tender: ITender
  key?: any
}

type FormValues = {
  documentRequirements: DocumentSubmissionRequirement[]
}

export const RequiredDocsSubmissionTab = ({ tender }: Props) => {
  const { t } = useTranslation()
  const [page, setPage] = useQueryState('page', 0)
  const rowsPerPage = 10

  const args = {
    page,
    size: rowsPerPage,
    lotId: tender.lot.id,
  } as const

  const { data: submissions, isLoading: isSubmissionsLoading } =
    useSubmissionsOverviewQuery(args, {
      skip: !tender,
      refetchOnMountOrArgChange: true,
    })

  const { data: lot, isLoading: isLotLoading } = useLotQuery({
    id: tender.lot.id ?? '',
  })

  const methods = useForm<FormValues>({
    defaultValues: {
      documentRequirements: [],
    },
  })

  const { control, reset, setValue } = methods

  const { fields } = useFieldArray({
    control,
    name: `documentRequirements`,
  })

  if (isLotLoading) {
    return <Loading fullPage={false} />
  }

  if (submissions === undefined || lot === undefined) {
    return <></>
  }

  return (
    <Stack spacing={1}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ backgroundColor: 'primary.main', p: 2 }}
      >
        <Typography variant="body2" color="white">
          {`${t('lot-name')}: ${lot.name}`}
        </Typography>
      </Stack>
      <Divider flexItem />
      <LotInformation lot={lot} />
      <Divider flexItem />
      <Box sx={{ maxWidth: '100%' }}>
        {submissions.items.length > 0 &&
          submissions.items.map((sub) => {
            return (
              <RequiredDocsSubmissionItem
                key={sub.id}
                lot={lot}
                submissionId={sub.id}
                submissionItem={sub}
              />
            )
          })}
        {submissions.info.totalRows !== 0 && (
          <TablePagination
            total={submissions.info.totalRows}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={setPage}
          />
        )}
      </Box>
    </Stack>
  )
}
